"use client"

import {NewsSearch} from "@/components/custom/newsPage/NewsSearch";
import {NewsCarousel} from "@/components/custom/carousel/newsCarousel";
import {Post} from "@/root/payload-types";
import {useState} from "react";
import {ArticleCard} from "@/components/custom/cards/articleCard";
import {useLocale} from "@/hooks/useLocale";
import {LayoutSwitch} from "@/components/ui/layoutSwitch";

interface SectionBodyProps {
    news: Post[];
    showSearch: boolean;
    useAbsolutePath: boolean;
    view?: "list" | "grid" | "carousel";
}

export function SectionBody({ news, showSearch, useAbsolutePath, view = "carousel" }: SectionBodyProps) {
    const locale = useLocale();

    const [searchResults, setSearchResults] = useState<Post[]>([]);

    return (
        <div className={"flex flex-col gap-4"}>
            {showSearch && (
                <NewsSearch
                    news={news}
                    searchResults={searchResults}
                    setSearchResults={setSearchResults}
                    view={view}
                />
            )}
            {(searchResults.length <= 0 && view === "carousel") && (
                <NewsCarousel
                    posts={news}
                    className={"col-span-full"}
                    useAbsolutePath={useAbsolutePath}
                />
            )}
            {(searchResults.length <= 0 && view === "list") && (
                news.map((post) => (
                    <ArticleCard
                        key={post.id}
                        bgColor={"primary"}
                        url={`${locale}/news/${post.id}`}
                        post={post}
                        useAbsolutePath={useAbsolutePath}
                        view={"list"}
                    />
                ))
            )}
            {(searchResults.length <= 0 && view === "grid") && (
                <div className={"grid grid-cols-3 gap-2"}>
                    {news.map((post) => (
                        <ArticleCard
                            key={post.id}
                            bgColor={"primary"}
                            url={`${locale}/news/${post.id}`}
                            post={post}
                            useAbsolutePath={useAbsolutePath}
                        />
                    ))}
                </div>
            )}
        </div>
    )
}